import styled from 'styled-components'
import CardPostulation from '../card'

export const PostulacionesCard = styled(CardPostulation)`
  margin-bottom: 12px;
  background-color: #fff;
  border-radius: 8px;
`
